import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { translate } from 'react-i18next'; 

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

import { _parsePhoneNumber } from '../../partials/validateNumber';

const styles = theme => ({ 
  DialogContent: {
      paddingBottom: '0', 
  }, 
});

class MaxWidthDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            fullWidth: true,
            maxWidth: 'sm',
            newEmployee: [],
            checked: [],
            listEmployee: []
        }
    } 
    async componentDidMount(){
        this.props.onRef(this)  
    }
    handleClickOpen = (newEmployee, listEmployee) => { 
        this.setState({ open: true, newEmployee: newEmployee, listEmployee: listEmployee});
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleMaxWidthChange = event => {
        this.setState({ maxWidth: event.target.value });
    };

    handleFullWidthChange = event => {
        this.setState({ fullWidth: event.target.checked });
    };
    handleToggle = value => () => {
        const { checked } = this.state;
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
        newChecked.push(value);
        } else {
        newChecked.splice(currentIndex, 1);
        }

        this.setState({
        checked: newChecked,
        });
    };
    handleUpdate = () => { 
        let nonChecked = this.state.newEmployee.filter(e => this.state.checked.indexOf(e.userCode) === -1)
        let nonChecked_filter = nonChecked.map(function(ele){return ele.userCode})
        let ListEmployeeUpdate = this.state.listEmployee.filter(e => nonChecked_filter.indexOf(e.userCode) === -1)
        let totalSalary = 0
        ListEmployeeUpdate.map((employee)=>{
          return[
            totalSalary+= employee.bonusTotal,
            totalSalary+= employee.salary
          ]
           
        }) 
        this.props.handleUpdateSalary({ListEmployeeUpdate: ListEmployeeUpdate, totalSalary: totalSalary})
 
        // this.state.listEmployee.map

    }
    render() {
      const { classes, t } = this.props; 
      const {newEmployee} = this.state 
      return (
        <React.Fragment>
          {/* <Button variant="outlined" color="primary" onClick={this.handleClickOpen}>
            Open max-width dialog
          </Button> */}
          <Dialog
            fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="max-width-dialog-title"
          >
            <DialogTitle id="max-width-dialog-title" className={classes.DialogTitle}>{t('service_cost_salary_employee_confirm')}</DialogTitle> 
              {newEmployee.length ? 
              (
                  <DialogContent className={classes.DialogContent}>
                      <DialogContentText>
                          {t('service_cost_confirmUpdateSalary_select_new_employees_that_you_want_to_update_their_salary_for_this_month')}
                      </DialogContentText>  
                      <List className={classes.root}>
                          {newEmployee.length && newEmployee.map(employee => (
                          <ListItem key={employee.userCode} role={undefined} dense button onClick={this.handleToggle(employee.userCode)}>
                              <Checkbox
                              checked={this.state.checked.indexOf(employee.userCode) !== -1}
                              tabIndex={-1}
                              disableRipple
                              />
                              <ListItemText primary={`${employee.name}`+`   `+ _parsePhoneNumber(employee.countryCode, employee.mobile).format_internal} />
                              <ListItemSecondaryAction>
                              {/* <IconButton aria-label="Comments">
                                  <CommentIcon />
                              </IconButton> */}
                              </ListItemSecondaryAction>
                          </ListItem>
                          ))}
                      </List> 
                  </DialogContent>
              )
              :
              <DialogContent>
                  <DialogContentText>
                    {t('service_cost_confirmUpdateSalary_are_you_sure_you_want_to_update_salaries_of_all_employees')}
                  </DialogContentText> 
              </DialogContent> 
              } 
            <DialogActions>
             <Button onClick={this.handleClose} color="primary">
                {t('service_cost_salary_employee_cancel')}
              </Button>
              <Button onClick={this.handleUpdate} color="primary">
                {t('service_cost_salary_employee_confirm')}
              </Button>  
            </DialogActions>
          </Dialog>
        </React.Fragment>
      );
  }
}

MaxWidthDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};
 
export default ( translate("translations")(withStyles(styles, { withTheme: true })(MaxWidthDialog)));

